// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","text":"Hero_text__ht4xS","image":"Hero_image__zL6bt"};